import { ProposalsProps } from 'lib/types'
import { useProposalsData } from './ProposalInitialization'
import ProposalContactCard from './ProposalContactCard'
import './proposal.scss'
import ProposalGeneric from './ProposalGeneric'
import ProposalHusky from './ProposalHusky'
import ProposalTable from './ProposalTable'
import reliabilityImg from '../../../assets/icons/ivo-marketing/reliability.png'
import performanceImg from '../../../assets/icons/ivo-marketing/performance.png'
import globeImg from '../../../assets/icons/ivo-marketing/globe.png'
import warrantyImg from '../../../assets/icons/ivo-marketing/5.png'
import convenienceImg from '../../../assets/icons/ivo-marketing/convenience .png'
/*import '../print.scss'*/

const Proposals = ({ proposals }: IProps) => {

    const {
        siteDesignName,
        xProtectPlatform,
        overhead,
        userData,
        date,
        hasError,
        errorMessage,
        hardwareType,
        hasManagementServer,
        managementServerTableBody,
        supportedCamerasValue,
        totalNumberOfCameras
    } = useProposalsData(proposals)

    const proposalHighlights = [
        {
            image: reliabilityImg,
            headline: 'Reliability',
            body: 'Backed by global team of support representatives.',
            imageModifierClass: ''
        },
        {
            image: performanceImg,
            headline: 'Performance',
            body: 'Engineered and built with Dell Technologies.',
            imageModifierClass: ''
        },
        {
            image: globeImg,
            headline: 'Global Support network',
            body: 'From Milestone Systems',
            imageModifierClass: ''
        },
        {
            image: warrantyImg,
            headline: 'Warranty',
            body: 'Standard five-year warranty on all appliances in this series',
            imageModifierClass: 'proposal-highlights__image--warranty'
        },
        {
            image: convenienceImg,
            headline: 'Convenience',
            body: 'Comes pre-loaded with XProtect VMS for fast installation.',
            imageModifierClass: ''
        }
    ]

    return (
        <div className="xsd__proposal">
            {hasError && (
                <div className="msds-shadow-medium my-8 px-6 py-6 msds-text-body-0-bold msds-text-danger-red-1">
                    <div>We have run into an error while trying to calculate proposals</div>
                    <div>{errorMessage}</div>
                </div>
            )}
            {!hasError && (
                <div className="msds-shadow-medium my-8 px-6 py-4">
                    <div className="row py-4">
                        <div className="col-12 col-md-6 mb-4 mb-md-0">
                            <div className="msds-text-header-2-bold py-4">Proposal</div>
                            <div className="msds-text-body-0 pb-2">Configuration Date: <span className="proposal-header-information">{date}</span></div>
                            <div className="msds-text-body-0 pb-2">Configuration Name: <span className="proposal-header-information">{siteDesignName}</span></div>
                            <div className="msds-text-body-0 pb-2">Product: <span className="proposal-header-information">{xProtectPlatform}</span></div>
                            {hardwareType === 0 && (
                                <div className="msds-text-body-0 pb-2">System Overhead: <span className="proposal-header-information">{overhead}</span></div>
                            )}
                        </div>
                        <div className="col-12 col-md-5 offset-md-1 col-lg-4 offset-lg-2">
                            <ProposalContactCard userData={userData} />
                        </div>
                        {hardwareType === 0 && (
                            <ProposalGeneric proposals={proposals} />
                        )}
                        {hardwareType === 1 && (
                            <ProposalHusky proposals={proposals} />
                        )}
                        {hasManagementServer && (
                            <div className="col-12">
                                <div className="msds-text-header-3 py-2">Management server</div>
                                {(totalNumberOfCameras > 5000 || supportedCamerasValue === 5) && (
                                    <div className='row xsd-proposals-pdf'>
                                        <div className="col-12">
                                            <div className="server-settings__header msds-text-body-2-bold mt-2">Please contact presales for an optimized design.</div>
                                        </div>
                                    </div>
                                )}
                                {totalNumberOfCameras <= 5000 && supportedCamerasValue < 5 && (
                                    <div className="row">
                                        <div className="col-6">
                                            <ProposalTable
                                                title="management server specification"
                                                head={['processor type', 'os disk', 'disk type', 'ram']}
                                                body={[managementServerTableBody[0]]}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <ProposalTable
                                                title="database storage information"
                                                head={['quantity', 'disk type', 'disk size', 'raid type']}
                                                body={[managementServerTableBody[1]]}
                                                forceAlign={true}
                                            />
                                            <ProposalTable
                                                head={['SQL Edition']}
                                                body={[managementServerTableBody[2]]}
                                                forceAlign={true}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {hardwareType === 1 && (
                            <div className="col-12">
                                <div className="proposal-highlights row">
                                    {proposalHighlights.map((highlight) => (
                                        <div key={highlight.headline} className="col-12 col-sm-6 col-md-4 col-lg-2 mb-3 proposal-highlights__col">
                                            <div className="proposal-highlights__card msds-bg-gray-1">

                                                <div className={`proposal-highlights__image ${highlight.imageModifierClass}`}>
                                                    {highlight.image && (
                                                        <img src={highlight.image} alt="" aria-hidden="true" />
                                                    )}
                                                </div>
                                                <div className="proposal-highlights__content">
                                                    <div className="msds-text-body-0-bold msds-text-gray-10">
                                                        {highlight.headline}
                                                    </div>
                                                    {highlight.body && (
                                                        <div className="msds-text-body-1">
                                                            {highlight.body}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div className="msds-btn-group msds-btn-group--right no-print-container">
                            <button
                                id={"xsd__e2e-print-pdf-button"}
                                type="button"
                                className="msds-btn msds-btn--tertiary msds-btn--lg"
                                onClick={() => { window.print() }}>
                                print pdf
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

interface IProps {
    proposals: ProposalsProps
}
export default Proposals
